import styles from "./Para.module.scss";
import classNames from "classnames/bind";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faCircleInfo,
    faList,
} from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
const cx = classNames.bind(styles);
function Para({ data }) {
    const paraItem = document.getElementsByClassName(cx("para_item"));
    const long = document.getElementsByClassName(cx("long"));
    const handleClick = (e) => {
        long[0].classList.contains(cx("active")) &&
            long[0].classList.remove(cx("active"));
        e.target.classList.toggle(cx("active"));
        let i = 0;
        [...paraItem].forEach((item) => {
            if (item.classList.contains(cx("active"))) {
                return (i += 1);
            }
        });
        i === 4 && long[0].classList.add(cx("active"));
    };
    const handleShowPara = (e) => {
        const long = document.getElementsByClassName(cx("long"));
        const paraItem = document.getElementsByClassName(cx("para_item"));
        if (!long[0].classList.contains(cx("active"))) {
            long[0].classList.add(cx("active"));
            [...paraItem].forEach((item) => {
                if (!item.classList.contains(cx("active"))) {
                    return item.classList.add(cx("active"));
                }
            });
        } else {
            long[0].classList.remove(cx("active"));
            [...paraItem].forEach((item) => {
                return item.classList.remove(cx("active"));
            });
        }
    };

    // useEffect(() => {
    //     const paraItem = document.getElementsByClassName(cx("para_item"));
    //     [...paraItem].forEach((item) => {
    //         item.addEventListener("click", handleClick);
    //     });
    //     return () => {
    //         [...paraItem].forEach((item) => {
    //             item.removeEventListener("click", handleClick);
    //         });
    //     };
    // }, []);
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    return (
        <>
            <div className={cx("para_wrap")}>
                {!mediaQuery && (
                    <>
                        {" "}
                        <div className={cx("price_wrap")}>
                            <div>
                                <span>Giá công bố</span>
                                <p>{data.para.priceus || "-"} USD</p>
                            </div>
                            <div>
                                <span>Giá về Việt Nam</span>
                                <p>{data.para.pricevn || "-"} VND</p>
                            </div>
                        </div>
                        <span className={cx("price")}>
                            <FontAwesomeIcon icon={faCircleInfo} /> &nbsp; Giá
                            chênh lệch do tỷ giá khác thời điểm hoặc có thuế đặc
                            biệt nếu xe về Việt Nam
                        </span>
                    </>
                )}
                <div className={cx("para_title_wrap")}>
                    <h3 className={cx("para_title")}>Thông số kỹ thuật</h3>
                    {mediaQuery && (
                        <Tippy content="Xem tất cả thông số" placement="bottom">
                            <b className={cx("long")} onClick={handleShowPara}>
                                {/* <FontAwesomeIcon icon={faArrowDownShortWide} /> */}
                                <FontAwesomeIcon icon={faList} />
                            </b>
                        </Tippy>
                    )}
                    {!mediaQuery && (
                        <b className={cx("long")} onClick={handleShowPara}>
                            {/* <FontAwesomeIcon icon={faArrowDownShortWide} /> */}
                            <FontAwesomeIcon icon={faList} />
                        </b>
                    )}
                </div>
                <div className={cx("para_container")}>
                    <div className={cx("para_item")} onClick={handleClick}>
                        <div className={cx("para_item_head")}>
                            <span>Thiết kế - Trang bị</span>
                            <span>
                                <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                        </div>
                        <div className={cx("para_item_hide")}>
                            <div>
                                <span>Kiểu dáng :</span>
                                {data.type}
                            </div>
                            <div>
                                <span>Số chỗ ngồi :</span>
                                {data.para.sit} chỗ
                            </div>
                            <div>
                                <span>Kích thước :</span>
                                {data.para.size} mm
                            </div>
                            <div>
                                <span>Chiều dài cơ sở :</span>
                                {data.para.long} mm
                            </div>
                            <div>
                                <span>Cỡ mâm :</span>
                                {data.para.mam} inch
                            </div>
                        </div>
                    </div>
                    <div className={cx("para_item")} onClick={handleClick}>
                        <div className={cx("para_item_head")}>
                            <span>Động cơ - Hộp Số</span>
                            <span>
                                <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                        </div>
                        <div className={cx("para_item_hide")}>
                            <div>
                                <span>Động cơ :</span> {data.engine}
                            </div>
                            <div>
                                <span>Công suất :</span>
                                {data.para.watt}
                            </div>
                            <div>
                                <span>Mô men xoắn :</span>
                                {data.para.momem}
                            </div>
                            <div>
                                <span>Hộp số :</span>
                                {data.para.hopso}
                            </div>
                            <div>
                                <span>Tỷ lệ nén :</span> {data.para.tilenen}
                            </div>
                            <div>
                                <span>Dẫn động :</span> {data.para.dandong}
                            </div>
                        </div>
                    </div>
                    <div className={cx("para_item")} onClick={handleClick}>
                        <div className={cx("para_item_head")}>
                            <span>Tốc độ</span>
                            <span>
                                <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                        </div>
                        <div className={cx("para_item_hide")}>
                            <div>
                                <span>Tốc độ tối đa :</span>
                                {data.max} Km/h
                            </div>
                            <div>
                                <span>0 - 100 km/h :</span> {data.para.max100}{" "}
                                giây
                            </div>
                            <div>
                                <span>0 - 200 km/h :</span>
                                {data.para.max200} giây
                            </div>
                        </div>
                    </div>
                    <div className={cx("para_item")} onClick={handleClick}>
                        <div className={cx("para_item_head")}>
                            <span> Tính năng - An toàn </span>
                            <span>
                                <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                        </div>
                        <div className={cx("para_item_hide")}>
                            <div>
                                <span>Hệ thống phanh :</span> {data.para.phanh}{" "}
                            </div>
                            <div>
                                <span>Hệ thống treo :</span>
                                {data.para.treo}
                            </div>
                            <div>
                                <span>An toàn :</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Para;
